import {Box, Flex} from '@chakra-ui/react'

const LoadingMessage = ({type}: {type: any}) => {
  return (
    <Box mt={'24px'}>
      <Flex justifyContent={type === 'bot' ? 'start' : 'end'}>
        <Box
          p={'16px'}
          px={'30px'}
          borderRadius={
            type === 'bot' ? '2px 16px 16px 16px' : '16px 2px 16px 16px'
          }
          border={'2px solid #F0F0F0'}>
          <Box className="loading-message"></Box>
        </Box>
      </Flex>
    </Box>
  )
}

export default LoadingMessage
